export const SELECTORS = {
  ordersCartCounter: '.js-orders-cart-counter-container',
  name: '.js-cart-preview-popup__item-name',
  link: '.js-orders-cart-link',
  popupContainer: '.js-cart-preview-popup',
};
